import React, { useEffect, useState } from "react";
import "./HeroSection.css";
import AOS from "aos";
import "aos/dist/aos.css";

import hero1 from "../assets/slide1.webp";
import hero2 from "../assets/slide2.webp";
import hero3 from "../assets/slide3.webp";

// SEO-friendly slides
const slides = [
  {
    image: hero1,
    alt: "Modular Operation Theatre by Wellness Electromedical Systems Pvt Ltd Pune",
    heading: "Leaders in Modular Operation Theatres",
    subtitle:
      "State-of-the-art Modular OT solutions built for precision, hygiene, and performance — trusted by hospitals across India.",
  },
  {
    image: hero2,
    alt: "Modular ICU NICU PICU setup by WEMS India",
    heading: "ICU · PICU · NICU · Recovery Units",
    subtitle:
      "Comprehensive modular systems for critical care environments — designed to international standards with cutting-edge technology.",
  },
  {
    image: hero3,
    alt: "Modular OT installation and hospital infrastructure by WEMS Pune",
    heading: "Engineering Excellence in Healthcare",
    subtitle:
      "From design to installation, we deliver end-to-end modular infrastructure solutions tailored to your facility's needs.",
  },
];

function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      goToNext();
    }, 5000);

    return () => clearInterval(timer);
  }, [current]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const goToNext = () => {
    setAnimating(true);

    setTimeout(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
      setAnimating(false);
    }, 600);
  };

  const goTo = (index) => {
    if (index === current) return;

    setAnimating(true);

    setTimeout(() => {
      setCurrent(index);
      setAnimating(false);
    }, 600);
  };

  return (
    <section
      className="hero-section"
      id="hero"
      aria-label="Wellness Electromedical Systems Pvt Ltd Modular OT Manufacturer and Modular Operation Theatre Company in India"
    >
      {/* Hidden images for SEO indexing */}
      <div className="seo-hidden-images">
        {slides.map((slide, i) => (
          <img key={i} src={slide.image} alt={slide.alt} loading="lazy" />
        ))}
      </div>

      {/* Background Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${index === current ? "active" : ""}`}
          style={{ backgroundImage: `url(${slide.image})` }}
          aria-hidden={index !== current}
          role="img"
          aria-label={slide.alt}
        />
      ))}

      {/* Overlay */}
      <div className="hero-overlay" />

      {/* Content */}
      <div className={`hero-content ${animating ? "fade-out" : "fade-in"}`}>
        {/* Company Badge */}
        <div className="hero-badge" data-aos="fade-down" data-aos-delay="100">
          Wellness Electromedical Systems Pvt Ltd.
        </div>

        {/* Fixed SEO H1 */}
        <h1
          className="hero-h1-seo"
          data-aos="fade-up"
          data-aos-delay="150"
        >
          Modular OT Manufacturer in India
        </h1>

        {/* Dynamic Slide Heading */}
        <h2
          className="hero-h2-slide"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {slides[current].heading}
        </h2>

        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="350">
          {slides[current].subtitle}
        </p>

        <div className="hero-btns" data-aos="fade-up" data-aos-delay="500">
          <a href="/contact-modular-ot" className="hero-btn primary">
            Get in Touch
          </a>

          <a href="/modular-ot-services" className="hero-btn secondary">
            Our Services
          </a>
        </div>

        {/* Stats */}
        <div className="hero-stats" data-aos="fade-up" data-aos-delay="650">
          <div className="stat">
            <span className="stat-number">170+ OTs Installed </span>
          </div>

          <div className="stat-divider" />

          <div className="stat">
            <span className="stat-number">10+ Years Experience</span>
          </div>

          <div className="stat-divider" />

          <div className="stat">
            <span className="stat-number">130+ Hospital Clients</span>
          </div>
        </div>

        {/* Hidden SEO content */}
        <div className="seo-content">
          <p>
            Wellness Electromedical Systems Pvt Ltd. (WEMS) is a leading Modular
            OT manufacturer in India specializing in Modular Operation Theatre
            solutions, ICU, NICU, PICU, hospital infrastructure, cleanroom
            systems, and turnkey healthcare projects.
          </p>
        </div>
      </div>

      {/* Slide Indicators */}
      {/* <div className="hero-dots" role="tablist" aria-label="Slide controls">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`hero-dot ${index === current ? "active" : ""}`}
            onClick={() => goTo(index)}
            aria-label={`Go to slide ${index + 1}`}
            aria-selected={index === current}
            role="tab"
          />
        ))}
      </div> */}
    </section>
  );
}

export default HeroSection;